import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly currentUrlStorageKey = 'navigation_current_url';
  private readonly lastUrlStorageKey = 'navigation_last_url';

  constructor(
    private router: Router,
  ) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        const currentUrl = event.urlAfterRedirects;
        const previousUrl = sessionStorage.getItem(this.currentUrlStorageKey);

        if (previousUrl && previousUrl !== currentUrl) {
          sessionStorage.setItem(this.lastUrlStorageKey, previousUrl);
        }

        sessionStorage.setItem(this.currentUrlStorageKey, currentUrl);
      });
  }

  goBack(): void {
    const currentUrl = sessionStorage.getItem(this.currentUrlStorageKey);
    const lastUrl = sessionStorage.getItem(this.lastUrlStorageKey);

    this.router.navigateByUrl(lastUrl && lastUrl !== currentUrl ? lastUrl : '/');
  }

  navigateWithReservedId(route: string, reservedIdentificationId: string): void {
    this.router.navigate([route], {
      state: {reservedIdentificationId},
    });
  }

  navigateWithReservedIdAndReturnUrl(route: string, reservedIdentificationId: string, returnUrl: string): void {
    this.router.navigate([route], {
      state: {reservedIdentificationId, returnUrl},
    });
  }

  navigateToLoginWithReturnUrl(route: string, returnUrl: string): void {
    this.router.navigate([route], {
      state: {returnUrl},
    });
  }

  navigateToTeamsOrCards(isIndividuals: boolean, reservedIdentificationId: string): void {
    const route = !isIndividuals ? '/teams' : '/cards';
    this.navigateWithReservedId(route, reservedIdentificationId);
  }
}
